import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Table } from '@/components';

import { DataTableValue } from 'primereact/datatable';
import { ImportFCLData } from '@/types/tableImportFCL';
import { useLocation } from 'react-router-dom';

import { getTableColumns } from './tableColumns';

import './ImportFCLTable.scss';

type ImportFCLTableProps = {
  data?: ImportFCLData[];
  isLoading?: boolean;
  selectedItems: unknown[];
  handleSelectionChange: (e: { value: unknown }) => void;
  tipo?: 'Import' | 'Export' | 'VacioImportacion';
  disabled?: boolean;
};

const ImportFCLTable: FC<ImportFCLTableProps> = ({
  data,
  isLoading,
  selectedItems,
  handleSelectionChange,
  tipo,
  disabled = false,
}) => {
  const location = useLocation();
  const isExport = location.pathname.includes('exportacion-fcl');
  const { t } = useTranslation(['importFCL', 'exportFCL']);

  const tableColumns = useMemo(
    () => getTableColumns(t, isExport, tipo, disabled),
    [t, isExport, tipo, disabled]
  );

  return (
    <Table
      columns={tableColumns}
      data={data as DataTableValue[]}
      isLoading={isLoading}
      filterDisplay="menu"
      paginator
      selectableColumns={false}
      selectionId="oid"
      selectedItems={selectedItems as DataTableValue[]}
      onSelectionChange={handleSelectionChange}
      selectionMode="checkbox"
    />
  );
};

export default ImportFCLTable;
